// extracted by mini-css-extract-plugin
export default {"empty":"ListOfRooms_empty__Ikc0E","rooms__online":"ListOfRooms_rooms__online__-g8Fw"};